// extracted by mini-css-extract-plugin
module.exports = {"illustration":"Modal_illustration__2fT_H","title":"Modal_title__2kjGa","body":"Modal_body__2Zmaa","button":"Modal_button__HdwHK"};